import React, { useContext, useEffect } from "react";

import { DispatchContext } from "../../../context/domain/planning/DispatchContext";

import SummaryBar from "./dailySummary/SummaryBar";
import JobBox from "./JobBox";
import DatesBar from "./DatesBar";

const DispatchContent = ({ className = "" }) => {
  const { isDispatchCapturing, isReadOnly } = useContext(DispatchContext);

  // Prevents the default action of the click and keydown events when in readOnly mode
  useEffect(() => {
    if (isReadOnly) {
      const blockEvent = (e) => {
        const target = e.target;
        if (target.closest(`.readonly`) && !target.closest(`.dont-block`)) {
          e.preventDefault();
          e.stopPropagation();
        }
      };

      document.addEventListener("click", blockEvent, true);
      document.addEventListener("keydown", blockEvent, true);

      return () => {
        document.removeEventListener("click", blockEvent, true);
        document.removeEventListener("keydown", blockEvent, true);
      };
    }
  }, [isReadOnly]);

  return (
    <div
      className={`${className} px-2 font-inter ${isReadOnly ? "readonly pointer-events-none" : ""}`}
    >
      {isReadOnly && (
        <div className="my-2 bg-green-50 rounded-md shadow-md shadow-gray-500 font-bold text-emerald-950 text-center">
          READ ONLY MODE{" "}
        </div>
      )}
      <div
        className={`z-10 ${isDispatchCapturing ? "top-12 border-t-2 border-gray-700" : "sticky top-[82px]"}`}
      >
        <DatesBar />
      </div>
      <div className={`${isReadOnly && "mt-4"} mt-12`}>
        {!isReadOnly && <SummaryBar />}
      </div>
      <div className={`${isReadOnly && "mt-16"}`}>
        <JobBox />
      </div>
    </div>
  );
};

export default DispatchContent;
